import { memo } from 'react';
import { SANR_DISCORD } from 'r/constants/links';
import oopsImage from './oops.png';
import { Button } from '@/components/ui/button';

export default memo(UiError);

function UiError() {
  return (
    <div className="w-full min-h-screen flex flex-col items-center justify-center text-center bg-background px-2">
      <img
        src={oopsImage}
        alt="Oops"
        className="w-79 h-49.75 max-md:w-65.5 max-md:h-41.5"
      />
      <h2 className="text-xl font-bold text-foreground leading-12 max-md:text-lg max-md:max-w-65.5">
        Oops!
      </h2>
      <h2 className="text-xl font-bold text-foreground leading-12 max-md:text-lg max-md:max-w-65.5">
        Seems like something went wrong
      </h2>
      <p className="mt-4 text-base text-foreground max-md:max-w-65.5">
        Let us know about the issue in our{' '}
        <a
          href={SANR_DISCORD}
          target="_blank"
          rel="noopener noreferrer"
          className="text-primary underline inline"
        >
          Discord
        </a>
        .
        <br />
        We will look into it ASAP.
      </p>
      <div className="mt-8">
        <Button
          className="w-full rounded-lg"
          onClick={() => window.location.reload()}
          size="lg"
          variant="default"
        >
          Refresh
        </Button>
      </div>
    </div>
  );
}
